import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  selector: 'app-terms-conditions-modal',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    DialogModule,
    ButtonModule,
    CheckboxModule,
    ScrollPanelModule
  ],
  templateUrl: './terms-conditions-modal.component.html',
  styleUrls: ['./terms-conditions-modal.component.scss']
})
export class TermsConditionsModalComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() accepted = new EventEmitter<void>();
  
  agreed: boolean = false;

  constructor(private http: HttpClient) {}

  onClose(): void {
    // Only allow closing if terms are accepted
    if (this.agreed) {
      this.visible = false;
      this.visibleChange.emit(false);
      this.agreed = false;
    }
  }

  onAccept(): void {
    if (this.agreed) {
      this.accepted.emit();
      this.visible = false;
      this.visibleChange.emit(false);
      this.agreed = false;
    }
  }

  onVisibleChange(value: boolean): void {
    // Prevent closing without accepting
    if (!value && !this.agreed) {
      // Keep modal open if user tries to close without accepting
      this.visible = true;
      return;
    }
    this.visible = value;
    this.visibleChange.emit(value);
    if (!value) {
      this.agreed = false;
    }
  }

  onDownload(): void {
    const fileName = 'Terms-and-Conditions.pdf';
    
    // Construct absolute URL using current origin to ensure same protocol (HTTPS/HTTP)
    // This prevents mixed content issues in production
    const baseUrl = window.location.origin;
    const fileUrl = `${baseUrl}/assets/EasySalesOpsTC.pdf`;

    // Fetch the file as a blob with proper response type
    this.http.get(fileUrl, {
      responseType: 'blob',
      observe: 'response'
    }).pipe(
      map((response: HttpResponse<Blob>) => {
        // Get the blob from the response
        const blob = response.body;
        if (!blob) {
          throw new Error('File not found');
        }

        // Create a blob URL (this is always secure as it's a local blob)
        const url = window.URL.createObjectURL(blob);
        
        // Create a temporary link element
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        
        // Append to body, click, and remove
        document.body.appendChild(link);
        link.click();
        
        // Clean up after a short delay to ensure download starts
        setTimeout(() => {
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }, 100);
      }),
      catchError((error) => {
        console.error('Error downloading file:', error);
        
        // Fallback: Try direct download using absolute URL with same protocol
        try {
          const link = document.createElement('a');
          link.href = fileUrl;
          link.download = fileName;
          link.style.display = 'none';
          document.body.appendChild(link);
          link.click();
          setTimeout(() => {
            document.body.removeChild(link);
          }, 100);
        } catch (fallbackError) {
          console.error('Fallback download also failed:', fallbackError);
          // Last resort: open in new tab
          window.open(fileUrl, '_blank');
        }
        
        return of(null);
      })
    ).subscribe();
  }
}

